const store = {
  namespaced: true,
  state:{
    showModules:true
  },
  mutations:{
    SET_SHOW:(state,isShow)=>{
      state.showModules = isShow
    }
  },
  actions:{
    setShow:({commit},isShow)=>{
      commit('SET_SHOW',isShow)
    }
  }
}

export default store